import React, { useEffect, useMemo, useState } from 'react'
import { useProject } from 'hooks'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Heading from '@react/react-spectrum/Heading'
import Textfield from '@react/react-spectrum/Textfield'

import MediaUpload from 'components/MediaUpload'

import PARTIALS from './partials'

function SettingsForm() {
  const { project, updateProjectPart, type, canEdit } = useProject()
  const [settings, setSettings] = useState(project.meta)
  const [shouldSave, setShouldSave] = useState(false)

  useEffect(() => {
    if (settings && shouldSave && canEdit) updateProjectPart('meta', settings)
  }, [settings, shouldSave, canEdit])

  const onChange = (propName) => (value) => {
    if (canEdit) {
      setShouldSave(true)
      setSettings((s) => ({ ...s, [propName]: value }))
    }
  }

  const ProjectSections = useMemo(() => PARTIALS[type] || (() => <></>), [type])

  return (
    <div className='SettingsForm'>
      <section>
        <Heading size='4'>Project</Heading>

        <FieldLabel label='Title' labelFor='title'>
          <Textfield name='title' value={settings.title} onChange={onChange('title')} disabled={!canEdit} />
        </FieldLabel>

        <FieldLabel label='Thumbnail' labelFor='thumbnail'>
          <MediaUpload
            type='image'
            value={settings.thumbnail}
            onUpload={onChange('thumbnail')}
            projectId={settings.id}
            path={`thumbnail`}
            withTextfield={true}
            disabled={!canEdit}
          />
        </FieldLabel>
      </section>

      <ProjectSections settings={settings} disabled={!canEdit} onChange={onChange} />
    </div>
  )
}

export default SettingsForm
